import { useQuery } from '@tanstack/react-query';

import { medusaClient } from '@/services/apiClient';
import { DEFAULT_PAGE_SIZE } from '@/utils/const';

import { IStore } from '../types/api';
import { VendorFilter } from '../types/filter';

export const useFilteredVendors = (filters: Partial<VendorFilter>) => {
  return useQuery({
    queryKey: ['vendors-list'],
    queryFn: () => fetchFilteredVendors(filters),
    refetchOnWindowFocus: false,
  });
};

export const getFilterQuery = (filters: VendorFilter) => {
  const getOffset = () => {
    if (filters.page) {
      if (filters.limit) {
        return (filters.page - 1) * filters.limit;
      }
      return (filters.page - 1) * DEFAULT_PAGE_SIZE;
    }

    return 0;
  };

  return {
    offset: getOffset(),
    limit: filters.limit,
    q: filters.q,
  };
};

export const fetchFilteredVendors = async (filters: Partial<VendorFilter>) => {
  const query = getFilterQuery(filters);

  const response = await medusaClient.get<{
    stores: IStore[];
    offset: number;
    count: number;
  }>(`store/vendors-list`, { params: query });

  return response.data;
};
